import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Profile.css';
import { userApi, prizeApi } from '../api';
import AchievementBadges from './AchievementBadges';
import { Achievement } from '../types/achievements';
import { Prize } from '../types/prizes';
import { LINK_TO_SUBMIT_QUESTIONS } from './GameComponent';
const LINK_TO_GROUP = 'https://portal.onersac.com/your-groups/!hqSDkEQIqhYWwfCvFK:415.onersac.com';

interface UserStats {
  games_played: number;
  total_score: number;
  average_score: number;
  best_score: number;
  level: string;
  best_streak: number;
  current_streak: number;
  last_played: string | null;
  favorite_category: string | null;
  category_stats: {
    [key: string]: {
      games_played: number;
      total_score: number;
      best_score: number;
    };
  };
  achievements: Achievement[];
  balanceLevel: number;
}

const Profile: React.FC = () => {
  const [stats, setStats] = useState<UserStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [earnedPrizes, setEarnedPrizes] = useState<Prize[]>([]);
  const [nextPrize, setNextPrize] = useState<Prize | null>(null);

  const fetchData = async () => {
    try {
      const [statsResponse, prizesResponse] = await Promise.all([
        userApi.getStats(),
        prizeApi.getUserPrizes()
      ]);

      if (statsResponse.data.status === 'success') {
        const backendStats = statsResponse.data.stats;
        setStats(backendStats);
      }

      if (prizesResponse.data.status === 'success') {
        setEarnedPrizes(prizesResponse.data.earned_prizes);
        setNextPrize(prizesResponse.data.next_prize);
      }
    } catch (err) {
      setError('Failed to load profile data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const handleSubmitQuestions = () => {
    window.open(LINK_TO_SUBMIT_QUESTIONS, '_blank');
  };

  // const handleJoinGroup = () => {
  //   window.open(LINK_TO_GROUP, '_blank');
  // };


  if (loading) return <div className="profile-loading">Loading...</div>;
  if (error) return <div className="profile-error">{error}</div>;
  if (!stats) return <div className="profile-error">No stats available</div>;

  return (
    <div className="profile-container">
      <div className="profile-header">
        <h1 className="profile-title">Profile</h1>
        <div className="profile-level">{stats.level}</div>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Games Played</div>
          <div className="stat-value">{stats.games_played}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Average Score</div>
          <div className="stat-value">{stats.average_score.toFixed(1)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Best Score</div>
          <div className="stat-value">{stats.best_score}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Best Win Streak</div>
          <div className="stat-value">{stats.best_streak}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Current Streak</div>
          <div className="stat-value">{stats.current_streak}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Favorite Category</div>
          <div className="stat-value">{stats.favorite_category || 'None'}</div>
        </div>
      </div>

      <div className="question-submission-section">
        <div className="submission-card">
          <div className="submission-icon">💡</div>
          <div className="submission-content">
            <h3 className="submission-title">Share Your Expertise</h3>
            <p className="submission-text">Have security knowledge? Submit your own questions to challenge others!</p>
            <button className="submission-button" onClick={handleSubmitQuestions}>
              Submit Questions
            </button>
          </div>
        </div>
      </div>

      {/* Discussion Group Section */}
      {/* <div className="discussion-group-section">

        <div className="submission-card">
          <div className="submission-icon">👥</div>
          <div className="submission-content">
            <h3 className="submission-title">Connect with Other Players</h3>
            <p className="submission-text">Played the game? Join the discussion group to compare responses, swap strategies, and see how your instincts measure up.</p>
            <button className="submission-button" onClick={handleJoinGroup}>
              Join the Group!
            </button>
          </div>
        </div>
      </div> */}

      {/* {earnedPrizes.length > 0 && (
        <div className="prizes-section">
          <h2>Earned Prizes</h2>
          <div className="prize-items">
            {earnedPrizes.map((prize) => (
              <div key={prize.id} className="prize-item">
                <div className="prize-icon">{prize.icon}</div>
                <div className="prize-details">
                  <div className="prize-name">{prize.name}</div>
                  <div className="prize-description">{prize.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )} */}

      {/* {nextPrize && (
        <div className="next-prize-section">
          <h3>Next Prize Goal</h3>
          <div className="prize-items">
            <div className="prize-item locked">
              <div className="prize-icon">{nextPrize.icon}</div>
              <div className="prize-details">
                <div className="prize-name">{nextPrize.name}</div>
                <div className="prize-description">{nextPrize.description}</div>
                <div className="progress-text">
                  Progress: {stats?.balanceLevel || 0} / {nextPrize.required_level_ups} level-ups
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {stats.achievements && <AchievementBadges unlockedAchievements={stats.achievements} />}

    </div>
  );
};

export default Profile; 